import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["data-target", "aria-controls"]
const _hoisted_5 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["data-target", "aria-controls"]
const _hoisted_9 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["data-target", "aria-controls"]
const _hoisted_13 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = ["id"]
const _hoisted_16 = ["data-target", "aria-controls"]
const _hoisted_17 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = ["id"]
const _hoisted_20 = ["data-target", "aria-controls"]
const _hoisted_21 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = ["id"]
const _hoisted_24 = ["data-target", "aria-controls"]
const _hoisted_25 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = ["id"]
const _hoisted_28 = ["data-target", "aria-controls"]
const _hoisted_29 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_30 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_setting_panel = _resolveComponent("setting-panel")!

  return (_openBlock(), _createElementBlock("div", {
    class: "accordion",
    id: _ctx.idPrefix + '-accordion-root'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-doctor-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-doctor',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-doctor'
        }, " 医師 ", 8, _hoisted_4)
      ], 8, _hoisted_3),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-doctor',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-doctor-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.doctor,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "doctor"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_5),
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-nurse-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-nurse',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-nurse'
        }, " 看護師 ", 8, _hoisted_8)
      ], 8, _hoisted_7),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-nurse',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-nurse-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.nurse,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "nurse"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_9),
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-therapist-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-therapist',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-therapist'
        }, " 理学療法士 又は 作業療法士 ", 8, _hoisted_12)
      ], 8, _hoisted_11),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-therapist',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-therapist-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.therapist,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "therapist"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_13),
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-technician-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-technician',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-technician'
        }, " 医療技術員 ", 8, _hoisted_16)
      ], 8, _hoisted_15),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-technician',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-technician-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.technician,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "technician"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_17),
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-clerk-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-clerk',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-clerk'
        }, " 事務員 ", 8, _hoisted_20)
      ], 8, _hoisted_19),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-clerk',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-clerk-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.clerk,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "clerk"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_21),
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-skilled-laborer-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-skilled-laborer',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-skilled-laborer'
        }, " 技能労務員 ", 8, _hoisted_24)
      ], 8, _hoisted_23),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-skilled-laborer',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-skilled-laborer-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.skilledLaborer,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "skilled-laborer"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_25),
      _createElementVNode("div", {
        class: "card-header",
        id: _ctx.idPrefix + '-other-header'
      }, [
        _createElementVNode("button", {
          class: "btn btn-link",
          type: "button",
          "data-toggle": "collapse",
          "data-target": '#' + _ctx.idPrefix + '-other',
          "aria-expanded": "false",
          "aria-controls": _ctx.idPrefix + '-other'
        }, " その他 ", 8, _hoisted_28)
      ], 8, _hoisted_27),
      _createElementVNode("div", {
        id: _ctx.idPrefix + '-other',
        class: "collapse",
        "aria-labelledby": _ctx.idPrefix + '-other-header',
        "data-parent": '#' + _ctx.idPrefix + '-accordion-root'
      }, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_setting_panel, {
            "response-setting-item": _ctx.settings.other,
            onUpdateSettingItem: _ctx.onUpdatedSetting,
            "panel-name": "other"
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ], 8, _hoisted_29)
    ])
  ], 8, _hoisted_1))
}